import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {isOptionalString, isStringArray} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import type {EntityDraftCardProps} from './entity-draft-card.types';
import {EntityDraftCard} from './entity-draft-card';

export const entityDraftCardRegistration = defineStreamComponentRegistration(
  StreamComponentType.ENTITY_DRAFT,
  EntityDraftCard,
  (props: Record<string, unknown>): EntityDraftCardProps | null => {
    if (!isStringArray(props.meta) || !isOptionalString(props.badge) || !isOptionalString(props.title) || !isOptionalString(props.description) || !isOptionalString(props.mediaUrl)) {
      return null;
    }

    return {
      badge: props.badge,
      meta: props.meta,
      title: props.title,
      description: props.description,
      mediaUrl: props.mediaUrl,
    };
  }
);
